/**
 * This reducer is used for fetching batch allocations
 */
import {
    GET_BATCH_ALLOCATIONS,
    GET_BATCH_ALLOCATIONS_SUCCESS,
    GET_BATCH_ALLOCATIONS_FAILURE,
    RESET_BATCH_ALLOCATION,
} from '../actions';

const initialState = {
    batchAllocations: [],
    loading: false,
    statusCode: 0,
    statusMessage: '',
    batchReceived: [],
    pendingCfns: [],
};

const batchAllocationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_BATCH_ALLOCATIONS: {
            const incomingCfns = Array.isArray(action.payload?.cfn)
                ? action.payload.cfn
                : action.payload?.cfn
                ? [action.payload.cfn]
                : [];
            return {
                ...state,
                loading: true,
                pendingCfns: [...state.pendingCfns, ...incomingCfns],
            };
        }
        case GET_BATCH_ALLOCATIONS_SUCCESS: {
            const fetchedCfns = new Set(
                (action.payload || []).map((a) => a.productCfn)
            );
            return {
                ...state,
                batchAllocations: [
                    ...state.batchAllocations,
                    ...action.payload
                ],
                batchReceived: [
                    ...state.batchReceived,
                    ...action.payload
                ],
                pendingCfns: state.pendingCfns.filter(
                    (cfn) => !fetchedCfns.has(cfn)
                ),
                statusCode: action?.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        }
        case GET_BATCH_ALLOCATIONS_FAILURE:
            return {
                ...state,
                batchAllocations: [],
                statusCode: action?.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case RESET_BATCH_ALLOCATION:
            return {
                ...initialState
            };

        default: {
            return { ...state };
        }
    }
};

export default batchAllocationsReducer;
